export const sortIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M9.5 10.999h3.2m-3.2-4H14m-4.5-4H15M4 14V1M1 12l3 3 3-3"/></svg>`,
    name: 'sort'
};